export const bowie_goose_01_puppies = [
    {title:"Puppies", url:"litters/previous/bowie_goose_2025/puppies"},
];